<template>
  <section class="section-panel">
    <header class="panel-head">
      <div>
        <h2 class="panel-title">{{ section.title }}</h2>
        <p v-if="description" class="panel-desc">{{ description }}</p>
      </div>
    </header>

    <slot v-if="state !== 'locked'" />

    <div v-else class="panel-empty">
      <div class="panel-empty-icon locked">
        <PortalIcon name="lock" :size="22" />
      </div>
      <div class="panel-empty-title">Aún no puede completar esta sección</div>
      <p class="panel-empty-text">
        Las secciones se completan en orden. Primero termine «{{ currentSection.title }}».
      </p>
      <button type="button" class="solid-btn" @click="$emit('edit', currentSection.step)">
        Completar {{ currentSection.title.toLowerCase() }}
      </button>
    </div>
  </section>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";
import { SECTIONS, applicationStep, sectionState } from "./candidateSummary";

// Frame of a portal tab showing one wizard step, whose fields are edited right there (see InlineSectionEditor):
// its content as soon as it can be completed, otherwise a prompt to go to the section that has to come first
// (emits "edit" with that section's step).
export default {
  name: "SectionPanel",
  components: { PortalIcon },
  props: {
    step: { type: Number, required: true },
    candidate: { type: Object, required: true },
    description: { type: String, default: "" },
  },
  computed: {
    section() {
      return SECTIONS[this.step];
    },
    state() {
      return sectionState(this.step, this.candidate);
    },
    currentSection() {
      return SECTIONS[Math.min(applicationStep(this.candidate), SECTIONS.length - 1)];
    },
  },
};
</script>

<style scoped>
.panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
}
.panel-title {
  margin: 0;
  font: 600 20px/1.3 "Geist", system-ui, sans-serif;
  letter-spacing: -0.02em;
  color: #0e1424;
}
.panel-desc {
  margin: 4px 0 0;
  font: 400 14px/1.5 "Geist", system-ui, sans-serif;
  color: #5d6578;
}
.panel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 36px 20px 40px;
  border: 1.5px dashed #e3e6ed;
  border-radius: 18px;
  background: #fafbfc;
}
.panel-empty-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.panel-empty-icon.locked {
  background: #f4f5f8;
  color: #9aa1b1;
  box-shadow: inset 0 0 0 1px #e6e8ee;
}
.panel-empty-title {
  font: 600 17px "Geist", system-ui, sans-serif;
  letter-spacing: -0.01em;
  color: #0e1424;
}
.panel-empty-text {
  max-width: 420px;
  margin: 6px 0 18px;
  font: 400 14px/1.5 "Geist", system-ui, sans-serif;
  color: #5d6578;
  text-wrap: pretty;
}
.solid-btn {
  height: 44px;
  padding: 0 20px;
  border: none;
  border-radius: 12px;
  background: #0e1424;
  box-shadow: 0 8px 18px -6px rgba(10, 16, 32, 0.6);
  color: #fff;
  font: 600 14px "Geist", system-ui, sans-serif;
  cursor: pointer;
}
.solid-btn:hover {
  background: #24304d;
}
</style>
